import { useQuery } from '@tanstack/react-query'

export interface CampaignBannerCandidate {
  id: string
  name: string
  bannerText: string | null
  linkedPostSlug: string | null
  bannerLinkUrl: string | null
  status: 'active' | 'scheduled'
  startsAt: string | null
  dismissible: boolean
}

export function useCampaignBanner() {
  return useQuery<CampaignBannerCandidate | null>({
    queryKey: ['campaign-banner'],
    queryFn: async () => {
      const response = await fetch('/api/campaigns/banner')
      if (!response.ok) throw new Error('Failed to fetch campaign banner')
      const data: { banner: CampaignBannerCandidate | null } =
        await response.json()
      return data.banner
    },
  })
}
